export enum AlertStatus {
  FIRING = 'firing',
  RESOLVED = 'resolved',
  UNKNOWN = 'unknown'
}
